__turbopack_context__.v({
  "paymentIcon": "h3ZG2q_paymentIcon",
});
